module.exports = __webpack_public_path__ + "img/guzhang.68928a56.png";